import HttpStatusCode from 'http-status-enum';


export interface IPepperError extends Error {
  code: string;
  httpCode: HttpStatusCode;
  data?: object;
  isRetryable?: boolean;
}

export function isPepperError(item: any): item is IPepperError {
  return typeof item.code === 'string' &&
      typeof item.httpCode === 'number' &&
      typeof item.message === 'string' &&
      (item.data ? typeof item.data === 'object' : true) &&
      (typeof item.isRetryable !== 'undefined' ? typeof item.isRetryable === 'boolean' : true);
}


export default class PepperError extends Error implements IPepperError {
  public name: string = 'Pepper Error';

  public static makeStdCode(code: number, prefix: string) {
    return 'E-' + prefix + '-' + ('0000' + code).slice(-4);
  }

  public getErrorCode = (): number => { return +this.code.slice(-4); };

  constructor(public code: string, public httpCode: HttpStatusCode,
      public message: string, public data?: object, public isRetryable?: boolean) {
    super();
  }
}
